import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  openPlaystoreAgent() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.crf.agent_builder');
  }
  openAppstoreAgent() {
    window.open(
      'https://apps.apple.com/in/app/clorent-factory-agent-builder/id1670704178');

  }
}
